import { all } from 'redux-saga/effects';
import commonSaga from './common-saga';
import cartSaga from './shopping-cart-saga';

const rootSaga = function* () {
  yield all([
    commonSaga(),
    cartSaga(),
  ]);
}

export default rootSaga;
